
<div class="" style="width: '100%'">
  <div *ngIf="popup_name === 'employeeLeaveAction'">
    <form *ngIf="permisosForm" [formGroup]="permisosForm">
      <div formArrayName="data" class="row">
        <div
          *ngFor="let permiso of permisosArray.controls; let i = index"
          [formGroupName]="i"
          class="mb-3 align-items-center"
        >
          <div class="col-4">
            <label class="form-label"
              >{{ permiso.get("permiso")?.value }}:</label
            >
            <input
              type="number"
              formControlName="value"
              class="form-control"
              (click)="getCustomLeave(permiso.get('idtipopermiso')?.value)"
            />
          </div>
        </div>
      </div>

      <div class="row text-right mt-4">
        <div class="col-12">
          <a class="btn btn-primary" (click)="submit()">Aceptar</a>
        </div>
      </div>
    </form>
    <div class="custom-card mt-3" *ngIf="data['idEmpleado'] == 0">
      <div class="card-header">
        <h5>Añadir nuevo tipo de Permiso</h5>
      </div>
      <div class="card-body">
        <form [formGroup]="leaveForm">
          <div
            style="
              display: flex;
              align-content: end;
              padding: 10px;
              text-align: right;
              width: 100%;
              gap: 50px;
            "
          >
            <input
              type="text"
              placeholder="Agregar nuevo tipo de permiso"
              formControlName="type"
              class="form-control"
              style="width: 40%"
            />
            <input
              type="number"
              placeholder="Valor"
              formControlName="value"
              class="form-control"
              style="width: 20%"
            />
            <input type="hidden" formControlName="idtipopermiso" />
            <button
              class="btn btn-primary"
              style="width: 20%"
              (click)="addNewLeaveType()"
            >
              Aceptar
            </button>

            <button
              *ngIf="leaveForm.get('idtipopermiso')?.value != 0"
              class="btn btn-danger"
              (click)="deleteLeaveType()"
            >
               <i class="pi pi-trash"></i>
            </button>
            <a
              class="btn bg-dark "
              (click)="reset()"
            >
              <i class="pi pi-replay"></i>
          </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
